export const VOUCHER_SETTING_LIST = "VOUCHER_SETTING_LIST";
export const UPDATE_VOUCHER_SETTING_STATUS = "UPDATE_VOUCHER_SETTING_STATUS";